module.exports = __webpack_public_path__ + "img/icon_volume.c489be54.svg";